import { requiredStepUpSIPForTarget } from "../../engine/calculations";

const config = {
  key: "req-step-up-sip",
  title: "Step-Up SIP Required For Target FV",
  category: "Target-Based",
  description: "Find the starting SIP amount you need if your contribution rises every year.",
  fields: [
    { key: "targetFV", label: "Target future value", type: "currency", default: 50_00_000, min: 1000, max: 100_00_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Years to target", type: "number", default: 15, min: 1, max: 40 },
    { key: "stepUpPct", label: "Annual step-up", type: "percent", default: 10, min: 1, max: 50, help: "How much you'll raise the monthly SIP each year." },
  ],
  compute(values) {
    const targetFV = Number(values.targetFV) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;
    const stepUpPct = (Number(values.stepUpPct) || 0) / 100;

    const requiredStartMonthly = requiredStepUpSIPForTarget(targetFV, annualRate, years, stepUpPct);

    return {
      headline: { label: "Required starting monthly SIP", value: requiredStartMonthly },
      breakdown: [
        { label: "Target future value", value: targetFV },
        { label: "Rises each year by", value: `${values.stepUpPct}%`, format: "text" },
      ],
    };
  },
};

export default config;
